export const linksAdmin = [
  {
    name: 'Dashboard',
    icon: 'home',
    path: '/admin/dashboard'
  },
  {
    name: 'Relatórios',
    icon: 'paper',
    path: '/admin/relatorios'
  },
  {
    name: 'Bolsistas',
    icon: 'list',
    path: '/admin/lista'
  },
  {
    name: 'Bolsas Expiradas',
    icon: 'cancel',
    path: '/admin/bolsas/expiradas'
  }
]
